import { Button } from "@/components/ui/button";
import { Navigation } from "lucide-react";
import { toast } from "sonner";

const PREF_KEY = "rtg_map_pref";
export const getMapPref = () => localStorage.getItem(PREF_KEY) || "auto"; // auto | google | apple
export const setMapPref = (v) => localStorage.setItem(PREF_KEY, v);

function isApple() {
  return /(iPhone|iPad|iPod|Mac OS)/.test(navigator.userAgent);
}

export function openNavigation(destination, origin = null) {
  if (!destination) return toast.error("No destination");
  const pref = getMapPref();
  const useApple = pref === "apple" || (pref === "auto" && isApple());
  const dest = encodeURIComponent(destination);
  const orig = origin ? encodeURIComponent(origin) : "";
  let url;
  if (useApple) {
    // Apple Maps
    url = `https://maps.apple.com/?daddr=${dest}${orig ? `&saddr=${orig}` : ""}&dirflg=d`;
  } else {
    // Google Maps
    url = `https://www.google.com/maps/dir/?api=1&destination=${dest}${orig ? `&origin=${orig}` : ""}&travelmode=driving`;
  }
  window.open(url, "_blank", "noopener");
}

export default function NavigateButton({ destination, origin, className = "", size = "default", testid = "navigate-btn" }) {
  return (
    <Button
      data-testid={testid}
      size={size}
      onClick={() => openNavigation(destination, origin)}
      className={`bg-amber-400 hover:bg-amber-300 text-zinc-950 font-bold ${className}`}
    >
      <Navigation className="h-4 w-4 mr-2"/> Navigate
    </Button>
  );
}
